import { FC, useMemo } from "react";
import { Outlet, useOutletContext, useParams } from "react-router-dom";
import { Header } from "@components/header";
import { AppMenuNavigate } from "@components/app-menu";
import { AWSUser } from "@archetypes/auth";
import ErrorPageLayout from "@components/error-page-layout";
import Error404Image from "@assets/404.svg";
import { useAppLive } from "@contexts/live-app.context";

const AppsLayout: FC = () => {
  const user = useOutletContext<AWSUser>();

  const {
    appData,
    isFormView,
    isAppView,
    isAppDataLoading,
    appError,
    menuTree,
    showLeftMenu,
    onHamburgerClick,
    onHeaderButtonClick,
  } = useAppLive();

  const { appId } = useParams();

  const context = useMemo(() => {
    return {
      fontColor: appData?.getApp?.fontColor,
      primaryColor: appData?.getApp?.primaryColor,
      secondaryColor: appData?.getApp?.secondaryColor,
      user,
    };
  }, [appData, user]);

  return (
    <main className="main-container">
      <div className="content-area w-100">
        {/* ✅ HEADER */}
        <div className="header-area">
          <Header
            basePath="/apps"
            user={user}
            isAppView={isAppView}
            appData={appData?.getApp}
            headerClassName={showLeftMenu ? "open" : ""}
            onHamburgerClick={onHamburgerClick}
            onHeaderButtonClick={onHeaderButtonClick}
            primaryColor={appData?.getApp?.primaryColor}
          />
        </div>

        <div className="flex justify-center">
          {isAppView && appError ? (
            <ErrorPageLayout
              title={appError.cause?.message ?? "Error Fetching App Details"}
              image={<img src={Error404Image} alt="error" />}
            />
          ) : (
            <>
              {/* ✅ SIDEBAR */}
              {isAppView && (
                <AppMenuNavigate menuData={menuTree} appId={appId as string} {...context} />
              )}

              {/* ✅ MAIN CONTENT */}
              <div className={`app-content-area ${isAppView || isFormView ? "" : "w-100"}`}>
                {!isAppDataLoading && <Outlet context={context} />}
              </div>
            </>
          )}
        </div>
      </div>
    </main>
  );
};

export default AppsLayout;
